/* eslint-disable no-unused-vars */
import { isTestEnvironmentRunning } from "sonobello.utilities.react";

import EnvironmentConfiguration from "../../../../constants/EnvironmentConfiguration";
import IHeatmappingClient from "../Types/IHeatmappingClient";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

const testingGoogleTagsManagerClient: IHeatmappingClient = {
  pushEvent: (event: unknown): void => {
    // eslint-disable-next-line no-console
    console.log("Google Tags Manager Event Pushed: ", event);
  }
};

const googleTagsManagerClient: IHeatmappingClient = {
  pushEvent: (event: unknown): void => {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push(event);
  }
};

// TODO: enable this when we no longer need to use prod google tags container for testing.
// const HeatmappingClient: IHeatmappingClient =
//   isTestEnvironmentRunning() || EnvironmentConfiguration.name === "Local"
//     ? testingGoogleTagsManagerClient
//     : googleTagsManagerClient;

const HeatmappingClient: IHeatmappingClient = googleTagsManagerClient;

export default HeatmappingClient;
